import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { HttpService } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { TerminalTransportRegistration, TerminalTransportRegistrationResult } from 'src/tmc-yard/model/terminal/transport-registration.model';
import { BarcodeScan } from 'src/tmc-common/model/terminal.model';

export class TransportRegistrationWithCodeController extends AbstractStepController {

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === TerminalContextConstants.registrationCode
      && contextChange.value != null && contextChange.value.replace(/\s+/g, '').length > 0) {
      this.onRegistrationCode();
    } else if (contextChange.key === 'barcodeScanned') {
      this.onBarcodeScanned();
    }
  }

  onRegisterToDashboardContext() {

  }

  onRegistrationCode() {

    const httpService = WizardServiceLocator.injector.get(HttpService);

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
    return httpService.postWithContext(`${environment.registrationCodeEndpoint}`, {
      code: this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode)
    }).toPromise().then((response: TerminalTransportRegistration) => {
      this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
      this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
      if (response.status !== ResponseStatus.FAILED) {

        const registration = new TerminalTransportRegistration(response);

        this.dashboardContext.setContextValue(TerminalContextConstants.carrier, registration.carrier);
        this.dashboardContext.setContextValue(TerminalContextConstants.supplier, registration.supplier);
        this.dashboardContext.setContextValue(TerminalContextConstants.driver, registration.driver);
        this.dashboardContext.setContextValue(TerminalContextConstants.coDriver, registration.coDriver);
        this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
        this.dashboardContext.setContextValue(TerminalContextConstants.trailerNumberPlate, registration.trailerNumberPlate);
        this.dashboardContext.setContextValue(TerminalContextConstants.orderReference, registration.orderReference);
        this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
        this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
        this.dashboardContext.setContextValue(TerminalContextConstants.selectedOptions, registration.selectedOptions);
        this.dashboardContext.setContextValue(TerminalContextConstants.phoneNumber, registration.phoneNumber);
        this.dashboardContext.setContextValue('string1', registration.string1);
        this.dashboardContext.setContextValue('string2', registration.string2);
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('register with code finished');

        if (this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStepRegistrationCode) {
          this.wizardComponent.next(this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStepRegistrationCode);
        } else {
          this.wizardComponent.next();
        }

      } else {
        this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
      }
    }, error => {
      //this.dashboardContext.setContextValue('errorM', );
    });
  }

  onBarcodeScanned() {

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
    this.validateRegistrationCodeAndGetTransportData();
  }

  private validateRegistrationCodeAndGetTransportData() {
    const httpService = WizardServiceLocator.injector.get(HttpService);

    const barcodeScan = new BarcodeScan({ value: this.dashboardContext.getContextValue('barcodeScanned') });
    httpService.postWithContext(environment.registrationTransportWithBarcodeEndpoint, barcodeScan)
      .toPromise().then((response: TerminalTransportRegistrationResult) => {

        this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
        this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
        if (response.status !== ResponseStatus.FAILED) {

          const registration = new TerminalTransportRegistration(response);

          this.dashboardContext.setContextValue(TerminalContextConstants.carrier, registration.carrier);
          this.dashboardContext.setContextValue(TerminalContextConstants.supplier, registration.supplier);
          this.dashboardContext.setContextValue(TerminalContextConstants.driver, registration.driver);
          this.dashboardContext.setContextValue(TerminalContextConstants.coDriver, registration.coDriver);
          this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
          this.dashboardContext.setContextValue(TerminalContextConstants.trailerNumberPlate, registration.trailerNumberPlate);
          this.dashboardContext.setContextValue(TerminalContextConstants.orderReference, registration.orderReference);
          this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
          this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
          this.dashboardContext.setContextValue(TerminalContextConstants.selectedOptions, registration.selectedOptions);
          if (this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStepQrCodeScanned) {
            this.wizardComponent.next(this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStepQrCodeScanned);
          } else {
            this.wizardComponent.next();
          }
        } else {
          this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
        }
      }, error => {
        // TODO specify what happens for bad codes
      });
  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('register with code started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {
    const matDialog = WizardServiceLocator.injector.get(MatDialog);
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
      confirm: () => {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    };
    matDialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    const showCreateNewRegistrationButton = this.wizardComponent.currentStep.dashboardConfiguration?.showCreateNewRegistrationButton;
    if (showCreateNewRegistrationButton === true) {
      this.dashboardContext.setContextValue('newRegistrationEnabled', true);
      const newRegistrationControl = new StepControl();
      newRegistrationControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.button.alternative';
      newRegistrationControl.type = StepControlType.BUTTON_STROKED;
      newRegistrationControl.iconAfterCss = 'fa-thin fa-angle-right';
      newRegistrationControl.controlAction = () => {
        this.wizardComponent.stopInactivityMonitoring();
        if (this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep != null) {
          this.wizardComponent.next(this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep);
        } else {
          this.wizardComponent.next('transport-registration-masterdata');
        }
      };
      controls.push(newRegistrationControl);
    } else {
      this.dashboardContext.setContextValue('newRegistrationEnabled', false);
    }
    this.dashboardContext.setContextValue('qrCodeScanEnabled', this.wizardComponent.currentStep.dashboardConfiguration?.qrCodeScanEnabled == true);

    this.dashboardContext.setContextValue('registrationCodeMinLength', this.wizardComponent.currentStep.dashboardConfiguration?.registrationCodeMinLength);
    this.dashboardContext.setContextValue('registrationCodeMaxLength', this.wizardComponent.currentStep.dashboardConfiguration?.registrationCodeMaxLength);

    return controls;

  }
}
